const getLocationSplitAddressComponents = addressComponents => {
  const location = {
    borough: '',
    city: '',
    country: '',
    postalCode: '',
    state: '',
    street: '',
    streetNumber: ''
  };
  addressComponents.forEach(locationEntry => {
    const locationType = locationEntry.types[0];

    switch (locationType) {
      case 'postal_code':
        location.postalCode = locationEntry.short_name;
        break;

      case 'street_number':
        location.streetNumber = locationEntry.short_name;
        break;

      case 'route':
        location.street = locationEntry.short_name;
        break;

      case 'locality':
        location.city = locationEntry.long_name;
        break;

      case 'sublocality_level_1':
        location.borough = locationEntry.long_name;
        break;

      case 'administrative_area_level_1':
        location.state = locationEntry.short_name;
        break;

      case 'country':
        location.country = locationEntry.short_name;
        break;
    }
  });
  return location;
};
var AddressFormatType;

(function (AddressFormatType) {
  /**
   * Example: '5905 Wilshire Blvd'
   */
  AddressFormatType["ADDRESS_1"] = "address1";
  /**
   * Example: 'Apt #101'
   */

  AddressFormatType["ADDRESS_2"] = "address2";
  /**
   * Example:
   * ```
   * [
   *   '5905 Wilshire Blvd, Apt #101',
   *   'Los Angeles, CA 90036',
   * ]
   * ```
   */

  AddressFormatType["MULTI_LINE"] = "multiLine";
  /** Example: '5905 Wilshire Blvd, Apt #101, Los Angeles, CA 90036' */

  AddressFormatType["ONE_LINE"] = "oneLine";
  /** Example: '5905 Wilshire Blvd, Apt #101 */

  AddressFormatType["ONE_LINE_STREET"] = "oneLineStreet";
  /**
   * Excludes apartment number, postal code.
   *
   * Example: '5905 Wilshire Blvd, Los Angeles, CA'
   */

  AddressFormatType["SHORT"] = "short";
  /**
   * Excludes apartment number, postal code.
   *
   * Example: '5905 Wilshire Blvd, Los Angeles'
   */

  AddressFormatType["SHORT_NO_STATE"] = "shortNoState";
})(AddressFormatType || (AddressFormatType = {}));

function formatAddressUS(location, // TODO: make last arg.
apartmentPrefix = 'Apt #', addressFormatType = AddressFormatType.ONE_LINE) {
  var _a;

  if (!location.addressComponents) return (_a = location.formattedAddress) !== null && _a !== void 0 ? _a : '';
  const splitAddressComponents = getLocationSplitAddressComponents(location.addressComponents);
  const streetNumber = splitAddressComponents.streetNumber ? `${splitAddressComponents.streetNumber} ` : '';
  const street = splitAddressComponents.street ? `${splitAddressComponents.street}` : '';
  const aptNumber = location.aptNumber ? `, ${apartmentPrefix}${location.aptNumber}` : '';
  const borough = splitAddressComponents.borough ? `${splitAddressComponents.borough}, ` : '';
  const boroughNoComma = splitAddressComponents.borough ? `${splitAddressComponents.borough}` : '';
  const city = splitAddressComponents.city ? `${splitAddressComponents.city}, ` : '';
  const cityNoComma = splitAddressComponents.city ? `${splitAddressComponents.city}` : '';
  const state = splitAddressComponents.state ? `${splitAddressComponents.state} ` : '';
  const postalCode = splitAddressComponents.postalCode ? `${splitAddressComponents.postalCode}` : '';

  switch (addressFormatType) {
    case AddressFormatType.ADDRESS_1:
      return `${streetNumber}${street}`;

    case AddressFormatType.ADDRESS_2:
      return `${aptNumber}`;

    case AddressFormatType.MULTI_LINE:
      return [`${streetNumber}${street}${aptNumber}`, `${borough}${city}${state}${postalCode}`];

    case AddressFormatType.ONE_LINE_STREET:
      return `${streetNumber}${street}${aptNumber}`;

    case AddressFormatType.ONE_LINE:
      return `${streetNumber}${street}${aptNumber}, ${borough}${city}${state}${postalCode}`;

    case AddressFormatType.SHORT:
      return `${streetNumber}${street}, ${borough}${city}${state}`;

    case AddressFormatType.SHORT_NO_STATE:
      return `${streetNumber}${street}${aptNumber}, ${boroughNoComma ? boroughNoComma : cityNoComma}`;
  }
}

export { AddressFormatType, formatAddressUS, getLocationSplitAddressComponents };
